import React, { useState } from 'react';
import '../scss/set-password-modal.style.scss';

interface SetPasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
}

type ModalStep = 'password' | 'otp' | 'success';

const SetPasswordModal: React.FC<SetPasswordModalProps> = ({ isOpen, onClose }) => {
  const [currentStep, setCurrentStep] = useState<ModalStep>('password');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [otp, setOtp] = useState('');

  const handleNextStep = () => {
    // TODO: Add validation
    if (currentStep === 'password') {
      // TODO: API call to initiate password setup
      setCurrentStep('otp');
    }
  };

  const handleVerifyOtp = () => {
    // TODO: Add OTP verification API call
    setCurrentStep('success');
  };

  const handleSuccess = () => {
    // Reset state and close modal
    setCurrentStep('password');
    setNewPassword('');
    setConfirmPassword('');
    setOtp('');
    onClose();
  };

  const handleModalClose = () => {
    // Reset state and close modal
    setCurrentStep('password');
    setNewPassword('');
    setConfirmPassword('');
    setOtp('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="set-password-modal-overlay" onClick={handleModalClose}>
      <div className="set-password-modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <h2 className="modal-title">
            {currentStep === 'password' && 'Set password'}
            {currentStep === 'otp' && 'OTP Verification'}
            {currentStep === 'success' && ''}
          </h2>
          {currentStep !== 'success' && (
            <button className="modal-close-btn" onClick={handleModalClose}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M18 6L6 18M6 6L18 18"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          )}
        </div>

        {/* Body Content */}
        <div className="modal-body">
          {currentStep === 'password' && (
            <>
              <div className="input-field">
                <label className="input-label">Set new password</label>
                <input
                  type="password"
                  className="input-box"
                  placeholder="Type here...."
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>
              <div className="input-field">
                <label className="input-label">Confirm new password</label>
                <input
                  type="password"
                  className="input-box"
                  placeholder="Type here...."
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
              <button className="modal-action-btn" onClick={handleNextStep}>
                <span>Next</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M6 12L10 8L6 4"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </>
          )}

          {currentStep === 'otp' && (
            <>
              <p className="otp-instruction-text">
                We have sent an OTP to your registered email ID to verify your password setup. Please enter to verify
              </p>
              <div className="input-field">
                <label className="input-label">Enter OTP</label>
                <input
                  type="text"
                  className="input-box"
                  placeholder="Type here...."
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />
              </div>
              <button className="modal-action-btn" onClick={handleVerifyOtp}>
                <span>Verify</span>
              </button>
            </>
          )}

          {currentStep === 'success' && (
            <>
              <div className="success-icon">
                <svg width="57" height="57" viewBox="0 0 57 57" fill="none">
                  <circle cx="28.5" cy="28.5" r="28.5" fill="#10B981" />
                  <path
                    d="M16 28.5L24.5 37L41 20.5"
                    stroke="white"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <p className="success-message">Your password has been updated successfully</p>
              <button className="modal-action-btn" onClick={handleSuccess}>
                <span>Okay</span>
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SetPasswordModal;
